import { Theme } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

const commonTitleStyle = {
  fontWeight: 700,
  fontSize: "16px",
  lineHeight: "24px",
};
const commonDescriptionStyle = {
  height: "36px",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "12px",
  padding: "12px 0",
};

export const useStyles = makeStyles((theme: Theme) => ({
  courseIdContainer: {
    fontWeight: 500,
    fontSize: "10px",
    lineHeight: "10px",
    color: "#4F545F",
    paddingBottom: "24px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    "& h3": {
      display: "inline",
      font: "inherit",
      margin: 0,
      flexShrink: 0,
      whiteSpace: "nowrap",
    },
  },
  horizontalLine: {
    margin: 0,
    flexGrow: 1,
    border: "none",
    borderTop: "1px solid #E0E0E0",
  },
  title: {
    ...commonTitleStyle,
    color: "#000000",
  },
  removeColumn: {
    [theme.breakpoints.down("sm")]: {
      paddingTop: "20px",
    },
  },
  columnHeader: {
    fontWeight: 500,
    fontSize: "10px",
    lineHeight: "10px",
    color: "#0D0D12",
    padding: "5px",
    textAlign: "center",
    [theme.breakpoints.down("md")]: {
      paddingTop: "10px",
      paddingLeft: "0px",
    },
  },
  description: {
    ...commonDescriptionStyle,
    color: "#4F545F",
    [theme.breakpoints.down("md")]: {
      lineHeight: "24px",
    },
  },
  iconBtn: {
    width: "45px",
    borderRadius: "2px",
    padding: "12px 10px 12px 10px",
    "&.Mui-focusVisible": {
      border: "2px solid #000000",
      borderRadius: "50px",
    },
  },
  iconClass: {
    height: "16px !important",
    width: "16px !important",
  },
  icon: {
    width: "14px !important",
    padding: "0px 10px 4px 0px",
    verticalAlign: "middle",
  },
  filledInfo: {
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "12px",
    color: "#4F545F",
    [theme.breakpoints.down("md")]: {
      lineHeight: "24px",
    },
  },
  filledInfoFirst: {
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "12px",
    color: "#4F545F",
    paddingTop: "12px",
    [theme.breakpoints.down("md")]: {
      lineHeight: "24px",
    },
  },
  additionalInfoIcon: {
    width: "14px !important",
    padding: "0px 10px 0px 0px",
    verticalAlign: "middle",
  },
  additionalNote: {
    lineHeight: "1.5",
    verticalAlign: "middle",
  },
  overflowText: {
    lineHeight: "1.5",
    overflowWrap: "break-word",
  },
  quantity: {
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "12px",
    color: "#0D0D12",
    paddingLeft: "0 8px",
  },
  infoList: {
    listStyleType: "none",
    padding: 0,
    margin: 0,
    width: "100%",
  },
  actionColumn: {
    display: "flex",
    alignItems: "center",
    minHeight: "60px",
  },
  actionDl: {
    margin: 0,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    "& dt": {
      margin: 0,
    },
    "& dd": {
      margin: 0,
    },
  },
  actionContent: {
    textAlign: "center",
  },
  priceContent: {
    padding: "14px 10px 14px 10px",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "12px",
    color: "#4F545F",
    textAlign: "center",
    [theme.breakpoints.down("md")]: {
      paddingLeft: "0px",
    },
  },
  qtyControls: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  delegateLabel: {
    flexGrow: 0,
    alignSelf: "flex-start",
  },
  delegateList: {
    maxWidth: "100%",
  },
  unavailableMessage: {
    color: "#ec1009",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "24px",
    fontStyle: "italic",
  },
  unavailableTitle: {
    ...commonTitleStyle,
    color: "#7a7171",
  },
  unavailableDescription: {
    ...commonDescriptionStyle,
    color: "#7a7171",
    [theme.breakpoints.down("md")]: {
      lineHeight: "24px",
    },
  },
}));
